export interface ILocationCreateRequest {
    submissionId: string;
    policyholderId: string;
    effectiveDate: Date;
    streetAddressLine1: string;
    streetAddressLine2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
    occupantComparisons: string[];
    name: string;
}

export class LocationCreateRequest implements ILocationCreateRequest {
    submissionId: string;
    policyholderId: string;
    effectiveDate: Date;
    streetAddressLine1: string;
    streetAddressLine2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
    occupantComparisons: string[];
    name: string;
}